import React from "react";
import SubscriptionTemporaryDiscountBadge from "./SubscriptionTemporaryDiscountBadge";
import { priceFormat } from "../../../helpers/calculateDiscountAndCredits";

const SubscriptionCardHeader = (props) => {
  const { cost, ticketsCount, temporaryDiscountValue, raffles, label } = props;

  const isDoublePrize = raffles && raffles.length > 1;

  const discountedCost = temporaryDiscountValue
    ? cost - temporaryDiscountValue
    : cost;

  const raffleLocation = (title) => {
    if (!title || !title.length) return "";
    return title.split(" ")[1];
  };

  const getTicketPrice = () => {
    if (ticketsCount) {
      const ticketCost = (discountedCost * 100) / ticketsCount;
      if (isDoublePrize) {
        return Math.round(ticketCost / 2);
      } else {
        return Math.round(ticketCost);
      }
    } else return null;
  };

  const ticketsData = (
    <div
      className={
        "subscription-bundle-body__header-tickets" +
        (isDoublePrize
          ? " subscription-bundle-body__header-tickets--double-prize"
          : "")
      }
    >
      <div className="subscription-bundle-body__tickets">
        <span className="subscription-bundle-body__tickets-value">
          {ticketsCount} tickets
        </span>
        <span className="subscription-bundle-body__tickets-label">
          {raffleLocation(raffles[0].title) || "basic"} Dream Home tickets
        </span>
      </div>
      {isDoublePrize && (
        <div className="subscription-bundle-body__tickets-separator">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0003 4.16669V15.8334M4.16699 10H15.8337"
              stroke="#E4ECEC"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}
      {isDoublePrize && (
        <div className="subscription-bundle-body__tickets">
          <span className="subscription-bundle-body__tickets-value">
            {ticketsCount} tickets
          </span>
          <span className="subscription-bundle-body__tickets-label">
            {raffleLocation(raffles[1].title) || "extra"} Dream Home tickets
          </span>
        </div>
      )}
    </div>
  );

  return (
    <div className="subscription-bundle-body__header">
      <div className="subscription-bundle-body__header-bg">
        <span></span>
        <span></span>
      </div>
      <SubscriptionTemporaryDiscountBadge discount={temporaryDiscountValue} />
      <div className="subscription-bundle-body__header-details">
        <div className="subscription-bundle-body__header-price-row">
          {temporaryDiscountValue ? (
            <p className="subscription-offer__price-discount">£{cost}</p>
          ) : null}
          <p className="subscription-offer__price">
            {priceFormat(discountedCost)}{" "}
            <span>
              / {priceFormat(discountedCost).length > 4 ? "m" : "month"}
            </span>
          </p>
        </div>
        <div className="subscription-bundle-body__header-price-row">
          {getTicketPrice() + "p / ticket"}
        </div>
        {ticketsData}
      </div>
      {label && <p className="subscription-bundle-body__header-label">{label}</p>}
    </div>
  );
};

export default SubscriptionCardHeader;
